module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxOCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogIzAwNUNBRjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggaWQ9ImlmX2xpa2VfMzA5MDU2IiBjbGFzcz0iY2xzLTEiIGQ9Ik0xNi40LDRBNS40LDUuNCwwLDAsMCwxMiw2LjMsNS40LDUuNCwwLDAsMCw3LjYsNCw1LjU5MSw1LjU5MSwwLDAsMCwyLDkuNkMyLDE0LDEyLDIyLDEyLDIyUzIyLDE0LDIyLDkuNkE1LjU5MSw1LjU5MSwwLDAsMCwxNi40LDRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMiAtNCkiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/if_like.svg
// module id = 604
// module chunks = 39